import React from 'react';
// import './shared/styles/app.scss';
import { useTheme } from './providers/ThemeProvider.tsx';
import { Route, Routes } from 'react-router';
import ProtectedRoute from './components/ProtectedRoute.tsx';
import MainPage from './views/MainPage.tsx';
import LoginPage from './views/LoginPage.tsx';
import SignupPage from './views/SignupPage.tsx';
import Dashboard from './views/Dashboard.tsx';

function App() {
  const { theme } = useTheme();

  return (
    <div className={theme}>
      <Routes>
        {/* <Route path="/" element={<MainPage />} /> */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
        </Route>
      </Routes>
      <div className="main-container"></div>
    </div>
  );
}

export default App;
